export default __webpack_public_path__ + "static/helvetica-fbff4e73a10216586fec3a1edfb4aa29.woff2";